/**
 * Nonce 生成工具
 * 纯前端工具，不依赖数据库连接
 */
import { createLogAdapter } from "@/lib/logger/console-adapter";

const uiLog = createLogAdapter("lib/utils/nonce-generator.ts");

/**
 * 生成安全的随机 nonce
 * 格式: timestamp-randomString (确保唯一性和时序性)
 */
export function generateNonce(): string {
	const timestamp = Date.now().toString();
	const random = Array.from(crypto.getRandomValues(new Uint8Array(16)))
		.map((b) => b.toString(16).padStart(2, "0"))
		.join("");

	return `${timestamp}-${random}`;
}

/**
 * 验证 nonce 格式是否正确
 * @param nonce 要验证的 nonce
 * @returns 是否格式正确
 */
export function isValidNonceFormat(nonce: string): boolean {
	if (!nonce || typeof nonce !== "string") {
		return false;
	}

	// 检查格式: timestamp-hexString
	const parts = nonce.split("-");
	if (parts.length !== 2) {
		return false;
	}

	const [timestamp, randomPart] = parts;

	// 验证时间戳部分是否为数字
	if (!/^\d+$/.test(timestamp)) {
		return false;
	}

	// 验证随机部分是否为32字符的十六进制字符串
	if (!/^[0-9a-f]{32}$/.test(randomPart)) {
		return false;
	}

	// 验证时间戳是否在合理范围内（最近1小时到未来10分钟）
	const nonceTime = parseInt(timestamp);
	const now = Date.now();
	const oneHourAgo = now - 60 * 60 * 1000;
	const tenMinutesFuture = now + 10 * 60 * 1000;

	if (nonceTime < oneHourAgo || nonceTime > tenMinutesFuture) {
		uiLog.warn(
			`Nonce时间戳验证失败: nonceTime=${nonceTime}, now=${now}, diff=${now - nonceTime}ms`,
		);
		return false;
	}

	return true;
}
